export const isPotentialEmail = (value: string) => value.includes('@');
